import { ApplyComponent } from './apply.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {RecaptchaModule, RecaptchaFormsModule} from 'ng-recaptcha';
import { from } from 'rxjs';
import {MatAutocompleteModule, MatInputModule, MatSelectModule,MatCheckboxModule } from '@angular/material';
import { FileUploadModule } from 'primeng/fileupload';
import { FooterComponent } from '../footer/footer.component';
import { NavbarComponent } from '../navbar/navbar.component';
import { NbCardModule, NbStepperModule,NbLayoutModule ,NbAccordionModule,NbInputModule,NbSelectModule, NbButtonModule, NbActionsModule, NbDatepickerModule, NbCheckboxModule,NbRadioModule,NbSpinnerModule } from '@nebular/theme';
//import { NbMomentDateModule } from '@nebular/moment';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { previewImg } from './dialog/transcriptpreview.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { EducationalFormComponent } from './dialog/educationalform.component';
import { NbAlertModule} from '@nebular/theme';
import { EducationalFormYearComponent } from './dialog/educationalformyearly.component';
import { addEducationalDetailsSemesterGPA } from './dialog/educationalformsemgpa.component';
import { addEducationalDetailsSemesterSGPI } from './dialog/educationalformsemsgpi.component';
import { addMasterEducationalDetailsSemesterSGPI } from './dialog/mastereducationalformsemsgpi.component';
import { EducationalFormBafComponent } from './dialog/educationalformbaf.component';
import {MatRadioModule} from '@angular/material/radio';
import { educationalformyearlyBcom } from './dialog/educationalformyearlyBcom.component';
import { addEducationalDetailsSemesterBVOCGPA } from './dialog/educationalformsemBVOCgpa.component';
import { EducationalFormYearAddOnComponent } from './dialog/educationalformyearlyAddOn.component';
import { EducationalFormYearSecndRowComponent } from './dialog/educationalformyearlySecondCol.component';
import { InternationalPhoneModule } from 'ng4-intl-phone';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SharedModule } from '../pages/shared-authpipe.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {MatIconModule} from '@angular/material/icon';
import { TranscriptDialogComponent } from './dialog/transcriptdialogcomponent';
import { addEducationalBAyearly } from './dialog/addEducationalBAyearly.component';
import { educationalformwithoutBBI } from './dialog/educationalformwithoutBBI.component';
import { educationalformsemsgpibscitnewformat } from './dialog/educationalformsemsgpibscitnewformat.component';





@NgModule({
  declarations: [ApplyComponent,FooterComponent,NavbarComponent,previewImg,EducationalFormYearAddOnComponent,EducationalFormComponent,EducationalFormYearComponent,addEducationalDetailsSemesterGPA,addEducationalDetailsSemesterSGPI,addMasterEducationalDetailsSemesterSGPI,EducationalFormBafComponent,EducationalFormYearSecndRowComponent,educationalformyearlyBcom,addEducationalDetailsSemesterBVOCGPA,TranscriptDialogComponent,addEducationalBAyearly,educationalformwithoutBBI,educationalformsemsgpibscitnewformat],
  imports: [
    CommonModule,
    NgxDocViewerModule,
    NbSpinnerModule,
    NbCardModule,
    NbStepperModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NbLayoutModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    NbAccordionModule,
    FileUploadModule,
    NbInputModule,
    NbSelectModule,
    NbDatepickerModule.forRoot(),
    // NbMomentDateModule,
    MatSelectModule,
    NbButtonModule,
    NbActionsModule,
    PdfViewerModule,
    NbCheckboxModule,
    NbRadioModule,
    NbAlertModule,
    MatRadioModule,
    ConfirmDialogModule,
    InternationalPhoneModule,
    MatAutocompleteModule,
    SharedModule,
    MatInputModule,
    MatCheckboxModule,
    NgxMatSelectSearchModule,
    MatIconModule
  ],
  exports: [
    ConfirmDialogModule,
  ],
  entryComponents: [
    previewImg,
    EducationalFormComponent,
    EducationalFormYearComponent,
    addEducationalDetailsSemesterGPA,
    addEducationalDetailsSemesterSGPI,
    addMasterEducationalDetailsSemesterSGPI,
    EducationalFormBafComponent,
    educationalformyearlyBcom,
    addEducationalDetailsSemesterBVOCGPA,
    EducationalFormYearAddOnComponent,
    EducationalFormYearSecndRowComponent,
    TranscriptDialogComponent,
    addEducationalBAyearly,
    educationalformwithoutBBI,
    educationalformsemsgpibscitnewformat
  ]
})
export class ApplyModule { }
